<div class="payment-methods">
  <div class="payment-methods__label">
    <strong>Opciones de pago</strong> para estas habitaciones:
  </div>
  <div class="payment-methods__badge-container">
    @for (badge of badges; track badge.label) {
      <div class="payment-methods__badge-container__badge">
        <mb-icon-text>
          <mb-icon icon="{{ badge.icon }}"></mb-icon>
          <span>{{ badge.label }}</span>
        </mb-icon-text>
      </div>
    }
  </div>
</div>
